import { render, staticRenderFns } from "./CardAuthorTable.vue?vue&type=template&id=74ed4a63&scoped=true"
import script from "./CardAuthorTable.vue?vue&type=script&lang=js"
export * from "./CardAuthorTable.vue?vue&type=script&lang=js"
import style0 from "./CardAuthorTable.vue?vue&type=style&index=0&id=74ed4a63&prod&lang=css&scoped=true"
import style1 from "./CardAuthorTable.vue?vue&type=style&index=1&id=74ed4a63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ed4a63",
  null
  
)

export default component.exports